"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLangAndSave = exports.setLang = exports.getLang = void 0;
const gs = require("../index");
const langStorageKey = "gs-lang";
let _language = "en";
const langSaved = localStorage.getItem(langStorageKey);
if (langSaved)
    _language = langSaved;
function getLang() { return _language; }
exports.getLang = getLang;
function setLang(lang) {
    _language = lang.toLowerCase();
    gs.validation.localize(_language);
}
exports.setLang = setLang;
function setLangAndSave(lang) {
    _language = lang.toLowerCase();
    localStorage.setItem(langStorageKey, _language);
    gs.validation.localize(_language);
}
exports.setLangAndSave = setLangAndSave;
//# sourceMappingURL=localization.js.map